import {
  Box,
  Card,
  FormHelperText,
  Grid,
  InputLabel,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import InputField from "../../../../common/InputField";
import "../careDirective/CareDirective.scss";
import { PrimaryButton } from "../../../../common/Buttons";
import RadioButton from "../../../../common/RadioButton";
import {
  getHealthcareProxy,
  getHealthcareProxyAllQuestions,
  downloadPdfHealthProxyApi,
} from "../../../../services/documentServices";
import { QuestionByCategoryType } from "../../../../constants/constants";
import download from "../../../../assets/images/download.png";
import TextCapsule from "../../../../common/TextCapsule";
import { useParams } from "react-router-dom";
import { FormHeading, getKeyFromText } from "../../../../utils/Utilities";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";
import { Spinner } from "phosphor-react";

const Overview = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [allQuestions, setAllQuestions] = useState(null);
  const [initialValues, setInitialValues] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  async function fetchData() {
    setIsLoading(true);
    try {
      const result = await getHealthcareProxy(id);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        setInitialValues(result.payLoad);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  }

  async function fetchQuestions() {
    const result = await getHealthcareProxyAllQuestions(id);
    if (result?.success) {
      setAllQuestions(result.payLoad);
    }
  }

  useEffect(() => {
    fetchData();
    fetchQuestions();
  }, []);
  async function downloadPdf() {
    setIsFetching(true);
    await downloadPdfHealthProxyApi(id, t);
    setIsFetching(false);
  }
  return (
    <Card className="care-directive documents-card-height summary-table">
      {isLoading ? (
        <Box component="div" className="loader-container">
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        <Grid container>
          <Grid
            item
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="outer outer-pt-10"
          >
            <FormHeading variant="h4">{t("doc-tab-4")}</FormHeading>
            <div className="download">
              <div>
                {isFetching ? (
                  <Spinner />
                ) : (
                  <img
                    src={download}
                    height={16}
                    width={16}
                    onClick={downloadPdf}
                  />
                )}
                <Typography fontWeight={"bold"}>{t("download")}</Typography>
              </div>
            </div>
            <Typography variant="p" sx={{ mb: 4 }}>
              {t("sidebar-3-text-1")}
            </Typography>
            <div className="content">
              <Box
                className="document"
                padding={matches ? "20px 12px" : "44px"}
              >
                <div>
                  <Box component="div">
                    <Typography
                      variant="h4"
                      fontWeight="bold"
                      textAlign="center"
                      color="color.black"
                    >
                      {t("sidebar-3-text-1")}
                    </Typography>
                    <Typography
                      variant="p"
                      color="color.black"
                      fontWeight="bold"
                    >
                      {t("donor-detail")}
                    </Typography>
                    <br />
                    <Typography variant="p" color="color.black">
                      {t("d-detail-text")}
                    </Typography>
                    <Formik initialValues={initialValues} enableReinitialize>
                      {(formik) => {
                        return (
                          <Form>
                            <InputField
                              value={formik?.values?.donorDetail?.name || ""}
                              fullWidth
                              variant="standard"
                              label={t("input-5")}
                              name="name"
                              type="text"
                              sx={{ pointerEvents: "none" }}
                            />
                            <InputField
                              value={
                                formik?.values?.donorDetail?.dateOfBirth || ""
                              }
                              InputLabelProps={{ shrink: true }}
                              fullWidth
                              variant="standard"
                              label={t("input-2")}
                              name="dateOfBirth"
                              type="date"
                              sx={{ pointerEvents: "none" }}
                            />
                            <Grid container>
                              <Grid item xs={8}>
                                <InputField
                                  value={
                                    formik?.values?.donorDetail?.street || ""
                                  }
                                  fullWidth
                                  variant="standard"
                                  label={t("input-6")}
                                  name="street"
                                  type="text"
                                  sx={{ pointerEvents: "none" }}
                                />
                              </Grid>
                              <Grid item xs={4}>
                                <InputField
                                  value={
                                    formik?.values?.donorDetail?.houseNumber ||
                                    ""
                                  }
                                  fullWidth
                                  variant="standard"
                                  label={t("input-7")}
                                  name="houseNumber"
                                  type="text"
                                  sx={{ pointerEvents: "none" }}
                                />
                              </Grid>
                              <Grid item xs={8}>
                                <InputField
                                  value={
                                    formik?.values?.donorDetail?.city || ""
                                  }
                                  fullWidth
                                  variant="standard"
                                  label={t("input-8")}
                                  name="city"
                                  type="text"
                                  sx={{ pointerEvents: "none" }}
                                />
                              </Grid>
                              <Grid item xs={4}>
                                <InputField
                                  value={
                                    formik?.values?.donorDetail?.postalCode ||
                                    ""
                                  }
                                  fullWidth
                                  variant="standard"
                                  label={t("input-9")}
                                  name="postalCode"
                                  type="number"
                                  sx={{ pointerEvents: "none" }}
                                />
                              </Grid>
                            </Grid>
                            <InputField
                              value={formik?.values?.donorDetail?.email || ""}
                              fullWidth
                              variant="standard"
                              label={t("input-3")}
                              name="email"
                              type="email"
                              sx={{ pointerEvents: "none" }}
                            />
                            <InputField
                              value={formik?.values?.donorDetail?.phone || ""}
                              fullWidth
                              variant="standard"
                              label={t("input-4")}
                              name="phone"
                              type="string"
                              sx={{ pointerEvents: "none" }}
                              InputLabelProps={{ shrink: true }}
                            />
                            <Typography
                              variant="p"
                              fontWeight="bold"
                              color="color.black"
                            >
                              {t("attorney-detail")}
                            </Typography>
                            <br />
                            <Typography variant="p" color="color.black">
                              {t("a-detail-text")}
                            </Typography>
                            {initialValues !== null
                              ? initialValues?.attorneyDetails?.map(
                                (elem, index) => {
                                  return (
                                    <Box>
                                      <InputField
                                        fullWidth
                                        variant="standard"
                                        label={t("input-5")}
                                        name={`attorneyDetails[${index}].name`}
                                        type="text"
                                        value={
                                          formik.values?.attorneyDetails[
                                            index
                                          ]?.name || ""
                                        }
                                        sx={{ pointerEvents: "none" }}
                                      />
                                      <InputField
                                        InputLabelProps={{ shrink: true }}
                                        fullWidth
                                        variant="standard"
                                        label={t("input-2")}
                                        value={
                                          formik.values?.attorneyDetails[
                                            index
                                          ]?.dateOfBirth || ""
                                        }
                                        name={`attorneyDetails[${index}].dateOfBirth`}
                                        type="date"
                                        sx={{ pointerEvents: "none" }}
                                      />
                                      <InputField
                                        fullWidth
                                        variant="standard"
                                        label={t("input-12")}
                                        name={`attorneyDetails[${index}].address`}
                                        type="text"
                                        value={
                                          formik.values?.attorneyDetails[
                                            index
                                          ]?.address || ""
                                        }
                                        sx={{ pointerEvents: "none" }}
                                      />
                                      <InputField
                                        fullWidth
                                        variant="standard"
                                        label={t("input-3")}
                                        name={`attorneyDetails[${index}].email`}
                                        value={
                                          formik.values?.attorneyDetails[
                                            index
                                          ]?.email || ""
                                        }
                                        type="email"
                                        sx={{ pointerEvents: "none" }}
                                      />
                                      <InputField
                                        fullWidth
                                        variant="standard"
                                        label={t("input-4")}
                                        name={`attorneyDetails[${index}].phone`}
                                        value={
                                          formik.values?.attorneyDetails[
                                            index
                                          ]?.phone || ""
                                        }
                                        type="string"
                                        sx={{ pointerEvents: "none" }}
                                      />
                                      {index === 0 ? (
                                        <Box>
                                          <Typography varient="p">
                                            {t("a-detail-text-2")}
                                          </Typography>
                                          <TextCapsule
                                            showTooltip={true}
                                            key={elem.id}
                                            title={
                                              initialValues?.attorneyDetails
                                                .length === 1
                                                ? t(
                                                  getKeyFromText(
                                                    "solely represent"
                                                  )
                                                )
                                                : t(
                                                  getKeyFromText(
                                                    "jointly represent"
                                                  )
                                                )
                                            }
                                            width="20%"
                                            minWidth="auto"
                                            padding="15px 0px"
                                            textAlign="center"
                                            fontSize="14px"
                                            bgColor="color.magentaLight2"
                                            color="color.black"
                                          />
                                        </Box>
                                      ) : (
                                        ""
                                      )}
                                    </Box>
                                  );
                                }
                              )
                              : ""}

                            <Box component="div" textAlign="justify">
                              {t("a-detail-para")}
                            </Box>
                            <br />
                            <br />
                            <br />

                            <br />

                            {allQuestions?.sort((a, b) => a.sortingId - b.sortingId)?.map((question, index) => {
                              return (
                                <Box
                                  component="div"
                                  className="medical-care-container"
                                  key={index}
                                >
                                  <Typography variant="p" fontWeight="bold">
                                    {t(question?.translationKey) || ""}
                                  </Typography>
                                  <Box
                                    padding="0 2rem"
                                    component="div"
                                    className="section-1"
                                    sx={{ width: "100%" }}
                                  >

                                    <ol>
                                      {question?.questions.map(
                                        (elem, index) => {
                                          return (
                                            <div>
                                              {index === 0 && elem.questionType !== 0 && <>
                                                <Box
                                                  component="div"
                                                  className="sub-section-1"
                                                >
                                                  <Typography
                                                    variant="p"
                                                    marginRight="2.5rem"
                                                  >
                                                    {t("YES")}
                                                  </Typography>
                                                  {elem?.questionType !== 3 && <>
                                                    <Typography variant="p">
                                                      {t("NO")}
                                                    </Typography>
                                                  </>
                                                  }
                                                </Box>
                                              </>
                                              }
                                              <li>
                                                <Box
                                                  component="div"
                                                  key={index}
                                                  className="sub-section-2"
                                                >
                                                  <Typography
                                                    variant="p"
                                                    margin="0 0.5rem"
                                                    width="80%"
                                                  >
                                                    {t(elem?.translationKey)}
                                                  </Typography>
                                                  {!elem?.subQuestions
                                                    ?.length && (
                                                      <>
                                                        {elem?.questionType === 1 &&
                                                          <>
                                                            <RadioButton
                                                              value="0"
                                                              theme="box"
                                                              paddingLeft="1rem"
                                                              checked={
                                                                elem?.healthProxyAnswer
                                                                  ?.answer === "yes"
                                                              }
                                                            />
                                                            <RadioButton
                                                              value="1"
                                                              theme="box"
                                                              checked={
                                                                elem?.healthProxyAnswer
                                                                  ?.answer === "no"
                                                              }
                                                            />
                                                          </>}
                                                        {elem?.questionType === 2 && <>

                                                          <Box
                                                            padding="0 2rem"
                                                            component="div"
                                                            className="representation-in-court-textarea"
                                                          >
                                                            <Typography
                                                              sx={{
                                                                mt: 2,
                                                                display: "flex",
                                                              }}
                                                            >
                                                              <textarea
                                                                id="w3review"
                                                                name="w3review"
                                                                rows="4"
                                                                cols="50"
                                                                defaultValue={elem?.healthProxyAnswer?.answer}
                                                                disabled
                                                              />
                                                            </Typography>{" "}
                                                          </Box>{" "}
                                                        </>}

                                                        {elem?.questionType === 3 && <div style={{ display: 'flex', marginRight: "1.5rem" }}>
                                                          <RadioButton
                                                            value="0"
                                                            theme="box"
                                                            paddingRight="4rem"
                                                            style={{ marginRight: "4rem" }}
                                                            checked={elem?.healthProxyAnswer
                                                              ?.answer === "yes"}

                                                          />
                                                          <div type="hidden" style={{ paddingLeft: "1rem" }} />
                                                        </div>}



                                                        {elem?.questionType === 4 && <>
                                                          <InputField
                                                            value={
                                                              elem?.healthProxyAnswer
                                                                ?.answer
                                                            }
                                                            InputLabelProps={{ shrink: true }}
                                                            fullWidth
                                                            variant="standard"
                                                            transKey={t("input-25")}
                                                            label={t("input-25")}
                                                            name="dateOfDeath"
                                                            type="date"
                                                            sx={{ pointerEvents: "none" }}
                                                          />
                                                        </>}
                                                      </>
                                                    )}
                                                </Box>
                                                {elem.subQuestions !== null && (
                                                  <>
                                                    {elem.subQuestions.map(
                                                      (sub, subIndex) => {
                                                        return (
                                                          <Box
                                                            component="div"
                                                            key={subIndex}
                                                            className="sub-section-2"
                                                          >
                                                            <Typography
                                                              color="color.magentaDark2"
                                                              variant="p"
                                                              margin="0 0.5rem"
                                                              width="80%"
                                                            >
                                                              {t(
                                                                sub?.translationKey
                                                              )}
                                                            </Typography>

                                                            <RadioButton
                                                              value="0"
                                                              theme="box"
                                                              paddingLeft="1rem"
                                                              checked={
                                                                sub
                                                                  ?.healthProxyAnswer
                                                                  ?.answer ===
                                                                  "yes"
                                                                  ? true
                                                                  : false
                                                              }
                                                            />
                                                            <RadioButton
                                                              value="1"
                                                              theme="box"
                                                              checked={
                                                                sub
                                                                  ?.healthProxyAnswer
                                                                  ?.answer !==
                                                                  "yes"
                                                                  ? true
                                                                  : false
                                                              }
                                                            />
                                                          </Box>
                                                        );
                                                      }
                                                    )}
                                                  </>
                                                )}
                                              </li>
                                            </div>

                                          );
                                        }
                                      )}
                                    </ol>
                                  </Box>
                                </Box>
                              );
                            })}
                            <br />

                            <br />
                            <Typography
                              sx={{ mt: 5 }}
                              variant="p"
                              paragraph
                              align="left"
                              color="color.black"
                            >
                              {t("input-20")}
                            </Typography>

                            <InputField
                              InputLabelProps={{ shrink: true }}
                              sx={{ pointerEvents: "none" }}
                              value={formik.values?.place || ""}
                              fullWidth
                              variant="standard"
                              name="name"
                              type="date"
                            />
                          </Form>
                        );
                      }}
                    </Formik>
                  </Box>
                  <Typography
                    sx={{ mt: 5 }}
                    variant="p"
                    paragraph
                    align="left"
                    color="color.black"
                  >
                    {t("doc-tab-3")}
                  </Typography>

                  <Typography
                    sx={{ mt: 5 }}
                    variant="p"
                    paragraph
                    align="center"
                    color="color.black"
                    fontStyle="italic"
                  >
                    {t("please-sign")}
                  </Typography>
                  <TextField
                    fullWidth
                    variant="standard"
                    name="sign"
                    type="text"
                    sx={{
                      pointerEvents: "none",
                    }}
                  />
                </div>
              </Box>
            </div>
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

export default Overview;
